// extracted by mini-css-extract-plugin
export default {"addToCartControl":"D3-z","giftCard":"E3-z","btnContainer":"F3-z","cartButton":"G3-z","disabled":"H3-z"};